import { Input } from '../ui/Input';
import { useState } from 'react';
import PanelWithClassification from '../PanelWithClassification';
import React from 'react';
import { apiService } from '../../utils/api';
import { debounce } from 'lodash';
import SolutionGallery from '../../features/database/solution/components/SolutionGallery';
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/Dialog';
import { Button } from '../ui/Button';
import {
  SolutionGalleryItem,
  SolutionPickerModalProps,
} from '../../features/database/solution/types';

const fetchData = async (
  url: string,
  id: string | null,
  extraParams: Record<string, unknown> = {}
): Promise<SolutionGalleryItem[]> => {
  return (
    await apiService.get<SolutionGalleryItem[]>('/api/v1/' + url, {
      params: {
        classification: id,
        pagination: false,
        ...extraParams,
      },
    })
  ).data;
};

const SolutionPickerModal = ({
  visible,
  classificationId,
  onSubmit,
  onClose,
  isMaterial = false,
  kind,
  title = 'Vyberte položku',
}: SolutionPickerModalProps) => {
  const [activeItemId, setActiveItemId] = useState<string | null>(null);
  const [selected, setSelected] = useState<SolutionGalleryItem | null>(null);
  const [items, setItems] = useState<SolutionGalleryItem[]>([]);

  const url = `left-panel-solution?classification=${classificationId ? classificationId : ''}${
    isMaterial ? '&is_material=true' : ''
  }${kind ? `&kind=${kind}` : ''}`;
  const pickerUrl = `solution/left-panel-picker/`;
  const kindParams = kind ? { kind } : {};

  const debounceSearch = debounce((e) => {
    handleSearch(e);
  }, 500);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!activeItemId) return;

    fetchData(pickerUrl, activeItemId, { ...kindParams, search: e.target.value || undefined })
      .then((data) => {
        setItems(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleMakeActive = async (id: string) => {
    setActiveItemId(id);

    try {
      const res = await fetchData(pickerUrl, id, kindParams);
      setItems(res);
    } catch (e) {
      console.log(e);
    }
  };

  const reset = () => {
    setActiveItemId(null);
    setSelected(null);
    setItems([]);
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSubmit = () => {
    if (selected) {
      onSubmit(selected);
      reset();
    }
  };

  return (
    <Dialog open={visible} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="sm:max-w-[1400px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody className="p-0">
          <div className="flex h-[465px] w-full">
            <div className="border-x border-neutral-200 mr-px">
              <PanelWithClassification
                makeActive={handleMakeActive}
                active={activeItemId}
                onSearch={() => {}}
                addItem={() => {}}
                onFilter={() => {}}
                className="h-[420px]!"
                url={url}
              />
            </div>
            <div className="w-full min-w-[350px]">
              <Input
                placeholder="Vyhledat"
                data-testid="solution-picker-search-input"
                onChange={debounceSearch}
                className="h-7.5"
              />
              <div className="h-[435px] overflow-auto">
                <SolutionGallery
                  solutions={items}
                  onSelect={(item: SolutionGalleryItem | null) => setSelected(item)}
                  selected={selected?.id}
                />
              </div>
            </div>
          </div>
        </DialogBody>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" data-testid="solution-picker-close-btn" onClick={handleClose}>
              Zavřít
            </Button>
          </DialogClose>
          <Button
            data-testid="solution-picker-confirm-btn"
            onClick={handleSubmit}
            disabled={!selected}
          >
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SolutionPickerModal;
